import { Reveal, SectionHead } from "@/components/Reveal";
import { WHY_CARDS } from "@/data/content";
import { Thermometer, Grid3x3, BellRing, Eye } from "lucide-react";

const ICONS = [Thermometer, Grid3x3, BellRing, Eye];

export const WhyThermal = () => (
  <section id="oplossing" className="relative scroll-mt-24 border-y border-white/5 bg-[#0c1319] py-24 md:py-36" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="02" overline="Waarom thermische detectie" title="Van reactief blussen naar eerder signaleren" />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {WHY_CARDS.map((card, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={card.nr} delay={i * 0.1} className="h-full">
              <article className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-[#10232F]/60 p-7 backdrop-blur-md transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-[#62C3F0]/40">
                <span className="pointer-events-none absolute -right-4 -top-6 font-heading text-7xl font-extrabold text-white/[0.04] transition-colors duration-500 group-hover:text-[#62C3F0]/10">
                  {card.nr}
                </span>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#2B9FD7]/30 bg-[#2B9FD7]/10 text-[#62C3F0]">
                  <Icon size={22} strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 font-heading text-lg font-bold text-[#F5F7F9]">{card.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#CBD3D9]/85">{card.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
